export function MeasureScreenSize(): number{
  const cs = window.innerWidth;
  return cs;
};
